import React, {Component} from 'react';
import {connect} from 'react-redux';
import NumberHelper from 'helpers/number-helper';
import Action from 'actions';
import Const from 'constants';
import {PATH_TO_IMAGES} from 'config';
import {calcSympathyPoints} from 'helpers/player-helper';

class PlayerSympathy extends Component {
    onClick(isActive) {
        const {playerId} = this.props;
        this.props.dispatch(
            Action.set('SettingPopupState', {
                playerId,
                isActive,
                settingName: this.getSettingName(),
            }),
        );
    }

    onChange(value) {
        const {playerId, userPointsType} = this.props;

        const player = this.getPlayer();
        const mode = this.getMode();

        this.props.dispatch(
            Action.set('PlayersSympathy', {
                [mode]: {
                    [playerId]: value,
                },
            }),
        );

        const points = calcSympathyPoints(
            player.getPropValueOfMode(userPointsType.getUserPointsType(), mode),
            Const.SYMPATHIES_LIST[value],
        );

        this.props.dispatch(
            Action.set(
                'UserPoints',
                [
                    {
                        playerId,
                        userPoints: NumberHelper.float(points, 3),
                    },
                ],
                mode,
                false,
            ),
        );

        this.onClick(false);
    }

    getPlayer() {
        const {players, playerId} = this.props;

        return players.getPlayer(playerId);
    }

    getMode() {
        const {mode = Const.FLEX_MODE, modesConfig} = this.props;
        const modeConfig = modesConfig.getConfig(mode);
        if (!isEmpty(modeConfig)) {
            return mode;
        }
        return Const.FLEX_MODE;
    }

    getSettingName() {
        return 'sympathy' + this.getMode();
    }

    render() {
        const {playerId, playerSettingPopup, playersSympathy} = this.props;

        const mode = this.getMode();
        const value = playersSympathy.getByPlayerIdAndMode(playerId, mode);
        const isActive = playerSettingPopup.isActive(playerId, this.getSettingName());

        return (
            <div className={`mood-holder${isActive ? ' active' : ''}`}>
                <button
                    type="button"
                    className="mood-icon"
                    onClick={() => this.onClick(!isActive)}
                    data-testid="mood-button"
                >
                    <img src={`${PATH_TO_IMAGES}/mood-${value}.svg`} alt={value} title={value} />
                </button>
                <div className="mood-drop">
                    {Object.keys(Const.SYMPATHIES_LIST).map((sympathy) => {
                        return (
                            <button
                                type="button"
                                key={`${sympathy}`}
                                className={`${sympathy}${sympathy === value ? ' selected' : ''}`}
                                onClick={() => ::this.onChange(sympathy)}
                            >
                                <span>{Const.SYMPATHIES_LIST[sympathy]}%</span>
                                <div className="icon-img">
                                    <img src={`${PATH_TO_IMAGES}/mood-${sympathy}.svg`} alt={sympathy} />
                                </div>
                                <span>{sympathy}</span>
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playersData, playerSettingPopup, modesConfig, playersSympathy, userPointsType} = state;

    return {
        players: playersData.players,
        playerSettingPopup,
        modesConfig,
        playersSympathy,
        userPointsType,
    };
}

export default connect(mapStatesToProps)(PlayerSympathy);

export {PlayerSympathy};
